import { Button, Group, Modal } from "@veneer/core";
import React from "react";

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;

  title: string;
  description: string | React.ReactNode;

  primaryLabel?: string;
  secondaryLabel?: string;

  onPrimary?: () => void;
  onSecondary?: () => void;

  align?: "start" | "center" | "end";
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  title,
  description,

  primaryLabel = "Continuar",
  secondaryLabel = "Cancelar",

  onPrimary,
  onSecondary,

  align = "start",
}) => {
  return (
    <Modal
      align={align}
      id="confirm-modal"
      show={open}
      onClose={onClose}
      title={title}
      footer={
        <Group>
          {secondaryLabel && (
            <Button appearance="secondary" onClick={onSecondary ?? onClose}>
              {secondaryLabel}
            </Button>
          )}

          {onPrimary && primaryLabel && (
            <Button onClick={onPrimary}>{primaryLabel}</Button>
          )}
        </Group>
      }
    >
      {typeof description === "string" ? <p>{description}</p> : description}
    </Modal>
  );
};
